import React from "react";
import ROUTES from "../../utils/routes";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
import LandingPage from "../../pages/LandingPage";
import LoginPage from "../../pages/LoginPage";
import RecoveryPage from "../../pages/RecoveryPage";
import RegisterPage from "../../pages/RegisterPage";
import EmailConfirmationPage from "../../pages/EmailConfirmationPage";
import PersonalAccountPage from "../../pages/PersonalAccountPage";
import RequireAuth from "../../components/RequireAuth";
import PaymentPage from "../../pages/PaymentPage";
import InvitePage from "../../pages/InvitePage";
import NewPasswordPage from "../../pages/NewPasswordPage";
import RulesPage from "../../pages/RulesPage";
import GreetingsPage from "../../pages/GreetingsPage";
import MeetPage from "../../pages/MeetPage";
import Extended57InstructionPage from "../../pages/Extended57InstructionPage";
import NotFoundPage from "../../pages/NotFoundPage";
import EndGamePage from "../../pages/EndGamePage";
import InGamePage from "../../pages/InGamePage";
import SupportPage from "../../pages/SupportPage";
import Conditions from "../../pages/Conditions";
import LandingContent from "../../pages/LandingPage/LandingContent";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import PrivacyPolicyNew from "../../pages/PrivacyPolicyNew";
import AdsLandingPage from "../../pages/AdsLandingPage";
import AdsLandingContent from "../../pages/AdsLandingPage/AdsLandingContent";
import ManualPage from "../../pages/ManualPage";
import ConditionsNew from "../../pages/ConditionsNew";
import LeaveReview from "../../pages/LeaveReview";
import InsightFormNewDescriptionPage from "../../pages/InsightFormNewDescriptionPage";
import InsightQuestionnairePage from "../../pages/InsightQuestionnairePage";
import InsightPickCards from "../../pages/InsightPickCards";
import InsightFormInstructionPage from "../../pages/InsightFormInstructionPage";
import InsightQuestionnaireFormPage from "../../pages/InsightQuestionnaireFormPage";
import App from "../../App";
import InsightQuestionnaireAnswersBothPage from "../../pages/InsightQuestionnaireBothPage";
import InsightFormRecommendationPage from "../../pages/InsightFormRecommendationPage";
import InsightFormRecommendationPairPage from "../../pages/InsightFormRecommendationPairPage";
import DemoResultTestPage from "../../pages/DemoResultTestPage";
import RegisterAfterDemoGamePage from "../../pages/RegisterAfterDemoGamePage";
import InGameEditPage from "../../pages/InGameEditPage";
import CompatibilitySharePage from "../../pages/CompatibilitySharePage";
import FeedbackPage from "../../pages/FeedbackPage";
import PwaInstructionsPage from "../../pages/PwaInstructions";
import RecoveryCodePage from "../../pages/RecoveryCodePage";
import LinkWasNotSentPage from "../../pages/LinkWasNotSentPage";

const routes = [];

routes.push({
  path: "*",
  component: <NotFoundPage />,
});
routes.push({
  path: ROUTES.LEAVE_REVIEW_PAGE,
  component: <LeaveReview />,
});
routes.push({
  path: ROUTES.PWA_INSTRUCTIONS_PAGE,
  component: <PwaInstructionsPage />,
});
routes.push({
  path: ROUTES.FEEDBACK_PAGE,
  component: <FeedbackPage />,
});
routes.push({
  path: ROUTES.SUPPORT_PAGE,
  component: <SupportPage />,
});
routes.push({
  path: ROUTES.LOGIN_PAGE,
  component: <LoginPage />,
});
routes.push({
  path: ROUTES.RECOVERY_PAGE,
  component: <RecoveryPage />,
});
routes.push({
  path: ROUTES.RECOVERY_CODE_PAGE,
  component: <RecoveryCodePage />,
});
routes.push({
  path: ROUTES.NEW_PASSWORD_PAGE,
  component: <NewPasswordPage />,
});
routes.push({
  path: ROUTES.REGISTER_PAGE,
  component: <RegisterPage />,
});
routes.push({
  path: ROUTES.REGISTER_AFTER_DEMO_PAGE,
  component: <RegisterAfterDemoGamePage />,
});
routes.push({
  path: ROUTES.EMAIL_CONFIRM_PAGE,
  component: <EmailConfirmationPage />,
});
routes.push({
  path: ROUTES.PAYMENT_INVITE_PAGE,
  component: (
    <RequireAuth>
      <InvitePage />
    </RequireAuth>
  ),
});
routes.push({
  path: ROUTES.RULES_PAGE,
  component: <RulesPage typeRule="common" />,
});
routes.push({
  path: ROUTES.ACCEPT_RULES_PAGE,
  component: (
    <RequireAuth>
      <RulesPage />
    </RequireAuth>
  ),
});
routes.push({
  path: ROUTES.MANUAL_PAGE,
  component: <ManualPage />,
});
routes.push({
  path: ROUTES.MEET_PAGE,
  component: <MeetPage />,
});
routes.push({
  path: ROUTES.EXTENDED_57_INSTRUCTION_PAGE,
  component: (
    <RequireAuth>
      <Extended57InstructionPage />
    </RequireAuth>
  ),
});
routes.push({
  path: ROUTES.IN_GAME_PAGE,
  component: <InGamePage />,
});
routes.push({
  path: ROUTES.END_GAME_PAGE,
  component: <EndGamePage />,
});
routes.push({
  path: ROUTES.LINK_WAS_NOT_SENT_PAGE,
  component: <LinkWasNotSentPage />,
});

const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" element={<App />}>
      <Route path="/gameads" element={<AdsLandingPage />}>
        <Route path="" index element={<AdsLandingContent />} />
      </Route>
      <Route element={<LandingPage />}>
        <Route index element={<LandingContent />} />
        <Route path="conditions" element={<Conditions />} />
        <Route path="conditions-payplus" element={<ConditionsNew />} />
        <Route path="privacy" element={<PrivacyPolicy />} />
        <Route path="privacy-payplus" element={<PrivacyPolicyNew />} />
      </Route>
      <Route
        path={ROUTES.PERSONAL_ACCOUNT_EDIT_PAGE}
        element={
          <RequireAuth>
            <PersonalAccountPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.PERSONAL_ACCOUNT_PAGE}
        element={
          <RequireAuth>
            <PersonalAccountPage />
          </RequireAuth>
        }
      />
      {/* разные key: иначе при «Попробовать снова» (результат → /payment) React
          переиспользует страницу, и новый заказ не создаётся */}
      <Route
        path={ROUTES.PAYMENT_PAGE}
        element={
          <RequireAuth>
            <PaymentPage key="payment" />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.PAYMENT_RESULT_PAGE}
        element={
          <RequireAuth>
            <PaymentPage key="payment-result" />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.MATCHES_PAGE}
        element={
          <RequireAuth>
            <DemoResultTestPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.GREETINGS_PAGE}
        element={
          <RequireAuth>
            <GreetingsPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.INSIGHT_INSIGHT_PICK_CARDS_PAGE}
        element={
          <RequireAuth>
            <InsightPickCards />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.INSIGHT_DESCRIPTION}
        element={<InsightFormNewDescriptionPage />}
      />
      <Route
        path={ROUTES.INSIGHT_RECOMMENDATION(":id")}
        element={
          <RequireAuth>
            <InsightFormRecommendationPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.INSIGHT_RECOMMENDATION_PAIR}
        element={
          <RequireAuth>
            <InsightFormRecommendationPairPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.INSIGHT_INSTRUCTION}
        element={
          <RequireAuth>
            <InsightFormInstructionPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.INSIGHT_QUESTIONNAIRE_PAGE}
        element={
          <RequireAuth>
            <InsightQuestionnairePage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.INSIGHT_QUESTIONNAIRE_FORM_PAGE()}
        element={
          <RequireAuth>
            <InsightQuestionnaireFormPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.DEMO_RESULT_PAGE}
        element={
          <RequireAuth>
            <DemoResultTestPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.IN_GAME_EDIT}
        element={
          <RequireAuth>
            <InGameEditPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.HISTORY_INSIGHT_QUESTIONNAIRE_FORM_PAGE()}
        element={
          <RequireAuth>
            <InsightQuestionnaireAnswersBothPage />
          </RequireAuth>
        }
      />
      <Route
        path={ROUTES.COMPATIBILITY_SHARE_PAGE}
        element={
          <RequireAuth>
            <CompatibilitySharePage />
          </RequireAuth>
        }
      />
      {routes.map(({ path, component, children }) => (
        <Route path={path} key={path} element={component} />
      ))}
    </Route>
  ),
  // Domain-aware basename. Wepurplay domains expose clean URLs without /game/;
  // in-touch.space keeps the historical /game/ prefix so existing links and
  // search engine indices stay valid.
  {
    basename:
      typeof window !== "undefined" &&
      ["wepurplay.com", "www.wepurplay.com", "wepurplay.ru", "www.wepurplay.ru"].includes(
        window.location.hostname
      )
        ? ""
        : "/game",
  }
);

export default router;
